module.exports = __webpack_public_path__ + "images/064c909754b2d6b88780a0de931dfcd0.svg";